let e = e => (Array.isArray(e) ? e : [e]),
  t = e => Number.parseInt(e, 10),
  r = e => e,
  s = Boolean,
  n = () => !0,
  a = Object.values,
  i = Object.entries,
  l = Object.hasOwn,
  o = Object.keys,
  u = Object.prototype.toString,
  c = Object.getPrototypeOf,
  y = e => 0 === e.length,
  f = e => e instanceof Error,
  b = e => y(o(e)),
  O = e => t => typeof t === e,
  j = O('string'),
  p = O('function'),
  g = e => null === e || ('function' != typeof e && 'object' != typeof e),
  m = e => {
    if (v(e) || !h(e) || '[object Object]' !== u.call(e)) return !1;
    let t = c(e);
    return null === t || t === A(e);
  },
  v = e => null == e,
  h = e => 'object' == typeof e && null !== e,
  A = e => {
    let t = c(e);
    return null === t ? e : A(t);
  },
  T = e => (t, r) => {
    let s = j(t) ? { level: t } : t;
    return 'level' in s ? e({ ...r, ...s }) : s;
  };
function d(e) {
  let [t, ...r] = e;
  if (f(t)) return [y(r) ? [t.message] : r, {}, t];
  if (h(t)) {
    if ('err' in t && f(t.err)) {
      let { err: e, ...s } = t;
      return [y(r) ? [e.message] : r, s, e];
    }
    return [r, t];
  }
  return [e, {}];
}
export {
  n as T,
  b as a,
  s as b,
  T as c,
  p as d,
  y as e,
  j as f,
  i as g,
  t as h,
  r as i,
  g as j,
  o as k,
  l as l,
  m as m,
  d as r,
  e as t,
  a as v
};
//# sourceMappingURL=read-arguments-CPC3VkQ4.mjs.map
